import type { Enums } from '@magicschool/supabase/types';
import { createStoreSlice, type SetField } from 'features/store/zustand';

type StateFilter = Enums<'room_state'> | 'all' | 'withAlerts' | 'administrated';
export type OrgRoomsStore = {
  setField: SetField<OrgRoomsStore>;
  stateFilter: StateFilter;
};

const defaultState = {
  stateFilter: 'all' as StateFilter,
};

export const createOrgRoomsStoreSlice = createStoreSlice('OrgRoomsStoreData', defaultState, ({ setField }) => ({
  setField,
}));
